import React from 'react'
import PropTypes from 'prop-types'

const InputDisplayTemplate = ({
  title,
  dataItem,
  isImage,
  imgClassName,
  containerClassName,
  isAddress,
  children,
}) => (
  <>
    <div className="row mx-1 py-2 ">
      <div className={`${containerClassName} col-6`}>
        <div className="span-title2 px-2 font-weight-bold">{title}</div>
      </div>
      {isAddress ? (
        <div className={`${containerClassName} col-6`}>
          <div className="text-uppercase span-input2">{children || "N/A"}</div>
        </div>
      ) : (
        <div className={`${containerClassName} col-6`}>
          {!isImage ? (
            <div className="text-uppercase span-input2">
              {dataItem || "N/A"}
            </div>
          ) : (
            <img className={`${imgClassName}`} src={dataItem} alt="" />
          )}
        </div>
      )}
    </div>
  </>
);

InputDisplayTemplate.defaultProps = {
  dataItem: "",
  title: "",
  isImage: false,
  imgClassName: "",
  containerClassName: "",
  isAddress: false,
  children: "",
};

InputDisplayTemplate.propTypes = {
  dataItem: PropTypes.node,
  title: PropTypes.string,
  isImage: PropTypes.bool,
  imgClassName: PropTypes.string,
  containerClassName: PropTypes.string,
  isAddress: PropTypes.bool,
  children: PropTypes.node,
};

export default InputDisplayTemplate